export class ProductRequirement {
  constructor(data) {
    // this.id = data.id;
    this.name = data.name;
    this.type = data.type;
    // this.description = data.description;
    // this.isRequired = data.isRequired;
    // this.isActive = data.isActive;
    // this.createdAt = data.createdAt;
    // this.updatedAt = data.updatedAt;
  }
}

// requirements: (tProduct?.qualityRequirements || []).map((requirement) => {
//         return {
//           typeId: requirement?.type || '',
//           typeName: requirement?.type || '',
//           nameId: requirement?.name || '',
//           name: requirement?.name || '',
//         };
//       }),
